import PropTypes from "prop-types";
import "../../styles/ComponentsStyles/Notification/PollingResultProgressBar.style.css";

const PollingResultProgressBar = ({
  color,
  background,
  name,
  designation,
  percentage,
}) => {
  return (
    <div
      className="pollingResultProgressBar flex-row align-center justify-between pt-05 pb-05 pl-1 pr-1 relative"
      style={{
        "--pollingResultProgressBarWidth": `${percentage}%`,
        "--pollingResultProgressBarBackground": background,
      }}
    >
      <div className="flex-col align-start-justify-start-g-05 z-4">
        <span className="t-14 poppins color-black">{name}</span>
        <span className="t-11 poppins color-grayColor">{designation}</span>
      </div>
      <span style={{ color: color }} className="t-14 poppins z-4">
        {percentage + "%"}
      </span>
    </div>
  );
};

PollingResultProgressBar.propTypes = {
  color: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  designation: PropTypes.string,
  percentage: PropTypes.number.isRequired,
};

PollingResultProgressBar.defaultProps = {
  designation: "", // fallback if not provided
};

export default PollingResultProgressBar;
